import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from 'src/service/auth.service';
import { WsAPiService } from 'src/app/ws-api.service';
import { LoadingService } from 'src/app/loading.service';
import { SignupPage } from '../signup/signup.page';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {

  @Input() modal = false;
  public name: string = "";
  public phonenumber: string = "";
  public username: string = "";
  public password: string = "";
  public hide: string;
  public uuid: string;
  showPassword = false;
  toggleShow() {
    this.showPassword = !this.showPassword;
  }

  constructor(public ws: WsAPiService,
    public loadingservice: LoadingService,
    private authService: AuthService) { }

  ngOnInit() {
  }


  async login() {

    if (!this.phonenumber || !this.password) {
      this.loadingservice.onAlert('ກະລຸນາປ້ອນຂໍ້ມູນໃຫ້ຄົບ');

    } else {

      this.loadingservice.onLoading('', 'ກະລຸນາລໍຖ້າ...');

      let data = {
        phonenumber: '+85620' + this.phonenumber + '',
        password: this.password
      }
      this.authService.login(data).subscribe(async res => {
        if (res.status == 1) {
          console.log('login success!!!!!!!!!!!!!', res);
          localStorage.setItem('user_phoneNumber', res.data.phonenumber.split('+85620')[1])


          // ============== gen wallet ==================
          this.checkWalletAndGenWallet({ uuid: res.data.uuid, token: res.data.token, sender: res.data.phonenumber });

          if (this.modal == false) {
            // localStorage.setItem('token', res.data?.uuid);
            localStorage.setItem('token', res.data.token);
            // this.get_login();
          } else {
            localStorage.setItem('token', res.data.token);
            // localStorage.setItem('token', res.data?.uuid);
            this.reload();
            this.loadingservice.alert_justOK('ການເຂົ້າສູ່ລະບົບສຳເລັດ');
          }

          this.ws.connect().then(res => {
            // this.ws.loginWS(localStorage.getItem('token'));
          });

          this.loadingservice.onDismiss();


        } else {
          console.log('cant login', res);
          this.loadingservice.onDismiss();
          this.loadingservice.onAlert('ກະລຸນາກວດສອບ ຊື່ ແລະ ລະຫັດຜ່ານຄືນໃໝ່');
        }
      }, async error => {
        console.log('errror', error);
        this.loadingservice.onDismiss();
        this.loadingservice.onAlert('ເກີດຂໍ້ຜິດພາດບາງຢ່າງ');
      })
    }
  }

  checkWalletAndGenWallet(v: any) {

    let data = {
      sender: v.sender,
      token: v.token
    }

    // check wallet
    this.authService.checkwallet(data).subscribe(res => {
      console.log('check wallet', res);
      if (!res.status) {

        let senddata = {
          uuid: v.uuid,
          limitBlock: 10,
          token: v.token,
          sender: v.sender
          // phonenumber: v.uuid,
          // passkey: v.passkeys
        }

        console.log('fffffff', senddata);


        // gen wallet
        this.authService.genwallet(senddata).subscribe(rx => {
          console.log('gen wallet', rx);

        }, error => {
          console.log(error);
        })
      }
    }, error => {
      console.log(error);

    })
  }

  get_signup() {
    this.loadingservice.showModal(SignupPage).then(r => {
      r.present();
      r.onDidDismiss().then(res => {

      })
    });
  }

  isNumber(evt) {
    evt = (evt) ? evt : window.event;
    var charCode = (evt.which) ? evt.which : evt.keyCode;

    if (charCode == 32 || (48 <= charCode && charCode <= 57)) { //backspace and number only
      return true;
    } else {
      return false;
    }
  }
  getcolor() {
    if (this.phonenumber.length < 8) {
      return 'medium'
    } else {
      return 'primary'
    }
  }
  dismiss() {
    this.loadingservice.closeModal({ 'dismissed': true });
    // this.modalCtrl.dismiss({
    //   'dismissed': true,
    // });
  }
  reload() {
    this.loadingservice.closeModal({ 'reload': true });

    // this.modalCtrl.dismiss({
    //   'reload': true,
    // });
  }
}
